module.exports = __webpack_public_path__ + "static/media/womens-channel.f190866b.jpg";